import { ReactNode } from 'react';

interface SecondaryButtonProps {
  children: ReactNode;
  onClick?: () => void;
  type?: 'button' | 'submit';
  className?: string;
  icon?: ReactNode;
  disabled?: boolean;
}

export function SecondaryButton({
  children,
  onClick,
  type = 'button',
  className = '',
  icon,
  disabled = false,
}: SecondaryButtonProps) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      aria-disabled={disabled}
      className={`h-[50px] px-4 rounded-[10px] bg-white transition-all duration-200 flex items-center justify-center gap-1.5 group border border-[#eee] ${
        disabled
          ? 'opacity-60 cursor-not-allowed'
          : 'hover:bg-gray-100 cursor-pointer'
      } ${className}`}
    >
      {icon && (
        <span className="text-[#908e8e] group-hover:text-[#8E2A2F] text-[18px] transition-colors flex items-center">
          {icon}
        </span>
      )}
      <span className="font-['DM_Sans',sans-serif] font-bold leading-[21px] text-[#908e8e] group-hover:text-[#8E2A2F] text-[14px] tracking-[-0.1px] transition-colors" style={{ fontVariationSettings: "'opsz' 14" }}>
        {children}
      </span>
    </button>
  );
}
